var Util = require('../../util');

module.exports = {
  getFirstScale: function getFirstScale(scales) {
    var firstScale;
    Util.each(scales, function (scale) {
      if (scale) {
        firstScale = scale;
        return false;
      }
    });
    return firstScale;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/component/lib/guide/util/helper.js
// module id = 190
// module chunks = 0 1 2